import { render } from "./Labelling.vue?vue&type=template&id=644cc5e7"
import script from "./Labelling.vue?vue&type=script&lang=js"
export * from "./Labelling.vue?vue&type=script&lang=js"

import "./Labelling.vue?vue&type=style&index=0&id=644cc5e7&lang=css"

import exportComponent from "/home/runner/work/acp-portal-frontend/acp-portal-frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__